import React from 'react';

import promotion_config from '../../../promotion_config';
import EntryForm from './entry_form';
import Error from './error';

import ticketFront from './ticket-front.png';
import ticketBack from './ticket-back.png';
import topCallout from './top-entry-callout.png';

import './style.scss';

export const EntryInner = ({ entry, drawTicket, game, actions }) => {
    return (
        <div className="entry-div">
            <img
                src={topCallout}
                alt="ENTER EARLY TO GET A CHANCE TO BE ENTERED IN BOTH DRAWINGS. ALL NON-WINNING TICKETS FROM DRAW 1 WILL BE ENTERED FOR A CHANCE TO WIN IN DRAW 2"
                className="img-responsive center-block full-width"
            />
            <div className="flush-row">
                <div className="col-sm-10 col-sm-offset-1 text-center entry-info">
                    <div className="description">
                        <p>
                            To enter, type the TICKET NUMBER and ENTRY NUMBER
                            from one (1) non-winning{' '}
                            <span className="emphasis">
                                $5 Route 66™ Road to $1,000,000!{' '}
                            </span>{' '}
                            eligible Illinois Lottery instant ticket where
                            indicated in the spaces below.
                        </p>
                    </div>
                    <div className="valid-entries">
                        <p>
                            Only valid Internet Entries shall be accepted.
                            <br />
                            Mailing tickets to the Lottery is not a valid form
                            of entry.
                        </p>
                    </div>
                </div>

                <div id="entry-alert">
                    <Error drawTicket={drawTicket} actions={actions} />
                </div>

                <div className="col-sm-10 col-sm-offset-1 entry-container">
                    <div className="entry-panel">
                        <EntryForm
                            promotion_id={promotion_config.promotion_id}
                            promotion={promotion_config.promotion}
                            appUrl={promotion_config.appUrl}
                            drawTicket={drawTicket}
                            entry={entry}
                            game={game}
                            actions={actions}
                            createfunc={
                                actions.drawTicketActions.enterDrawTicket
                            }
                        />
                    </div>
                </div>

                <div className="col-sm-12">
                    <div className="row row-eq-height">
                        <div className="col-xs-6 col-sm-5 col-sm-offset-1">
                            <div className="entry-panel">
                                <img
                                    src={ticketBack}
                                    alt="Ticket Back"
                                    className="img-responsive center-block full-width"
                                />
                                <div className="ticket-details">
                                    <p>
                                        The Ticket Number is a 14-digit number
                                        located on the back of the ticket.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-6 col-sm-5">
                            <div className="entry-panel">
                                <img
                                    src={ticketFront}
                                    alt="Ticket Front"
                                    className="img-responsive center-block full-width"
                                />
                                <div className="ticket-details">
                                    <p>
                                        The Entry Number is a 10-digit number
                                        that starts with 10 digits in the game
                                        play area on the on the front of the
                                        ticket.{' '}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EntryInner;
